<!-- src/app/timesheets/components/admin-timesheet-overview/admin-timesheet-overview.component.html -->
<div class="weekly-timesheet-wrapper admin-overview-wrapper">
  <div class="legend" *ngIf="!(busyService.loading$ | async)">
    <div class="legend-item">
      <span class="swatch approved"></span>
      <span>Approved Hours</span>
    </div>

    <div class="legend-item">
      <span class="swatch match"></span>
      <span>Clocked = Booked</span>
    </div>

    <div class="legend-item">
      <span class="swatch over-booked"></span>
      <span>Clocked &gt; Booked</span>
    </div>

    <div class="legend-item">
      <span class="swatch under-booked"></span>
      <span>Clocked &lt; Booked</span>
    </div>
  </div>

  <div class="week-nav" *ngIf="!(busyService.loading$ | async)">
    <button class="nav-btn" type="button" (click)="prev3()">← Previous</button>

    <h2 class="week-label">
      3 Week Report
      <span class="dates">
        ({{ visibleWeeks[0] }} - {{ visibleWeeks[visibleWeeks.length - 1] }})
      </span>
    </h2>

    <div class="nav-actions">
      <button class="nav-btn" type="button" (click)="next3()">Next →</button>
    </div>
  </div>

  <div class="filters-container" *ngIf="!(busyService.loading$ | async)">
    <div class="filters-row">
      <label class="filter-field">
        <span>Company</span>

        <select [(ngModel)]="selectedCompanyId" (ngModelChange)="onCompanyChange($event)">
          <option [ngValue]="null">All companies</option>

          <option
            *ngFor="let company of filterService.filterValues?.companies"
            [ngValue]="company.id"
          >
            {{ company.name }}
          </option>
        </select>
      </label>

      <label class="filter-field">
        <span>Department</span>

        <select [(ngModel)]="selectedDepartmentId" (ngModelChange)="onDepartmentChange($event)">
          <option [ngValue]="null">All departments</option>

          <option
            *ngFor="let department of filterService.filterValues?.departments"
            [ngValue]="department.id"
          >
            {{ department.code }} - {{ department.name }}
          </option>
        </select>
      </label>

      <label class="filter-field search-field">
        <span>Search</span>

        <input
          type="text"
          [(ngModel)]="filters.searchTerm"
          (ngModelChange)="onSearchTermChange($event)"
          placeholder="Search employee name"
        />
      </label>

      <div class="filter-actions">
        <button
          class="nav-btn clear-filters-btn"
          type="button"
          (click)="clearFilters()"
          [disabled]="!hasActiveFilters"
        >
          Clear Filters
        </button>
      </div>
    </div>
  </div>

  @if (busyService.loading$ | async) {
    <div class="loading-overlay">
      <div class="spinner"></div>
    </div>
  }

  @if (errorMessage) {
    <div class="error-message">
      {{ errorMessage }}
    </div>
  }

  @if (!(busyService.loading$ | async)) {
    <ng-container *ngIf="rows.length; else noEmployees">
      <div class="employee-card">
        <div class="timesheet-table-wrapper">
          <table class="timesheet-table">
            <thead>
              <tr>
                <th class="employee-col">Employee</th>

                @for (week of visibleWeeks; track week) {
                  <th>
                    {{ week }}
                    <div class="week-sub">Booked hrs</div>
                  </th>
                }
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let row of rows; trackBy: trackByEmployeeId">
                <td
                  class="employee-col clickable-cell"
                  (click)="openEmployee(row.employeeId, visibleWeeks[visibleWeeks.length - 1])"
                >
                  {{ row.name }} ({{ row.employeeId }})
                </td>

                @for (week of visibleWeeks; track week) {
                  <td
                    class="hour-cell clickable-cell"
                    [ngClass]="cellClass(row.weeks[week])"
                    (click)="openEmployee(row.employeeId, week)"
                    [title]="
                      'Booked: ' +
                      ((row.weeks[week]?.booked ?? 0) | number: '1.2-2') +
                      ' | Clocked: ' +
                      ((row.weeks[week]?.clocked ?? 0) | number: '1.2-2') +
                      ' | Scheduled: ' +
                      ((row.weeks[week]?.scheduled ?? 0) | number: '1.2-2')
                    "
                  >
                    <span class="hour-value">
                      {{ (row.weeks[week]?.booked ?? 0) | number: '1.2-2' }}
                    </span>

                    <div class="punch-tooltip">
                      <div>Booked: {{ (row.weeks[week]?.booked ?? 0) | number: '1.2-2' }}h</div>
                      <div>Clocked: {{ (row.weeks[week]?.clocked ?? 0) | number: '1.2-2' }}h</div>
                      <div>Scheduled: {{ (row.weeks[week]?.scheduled ?? 0) | number: '1.2-2' }}h</div>
                    </div>
                  </td>
                }
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <ng-template #noEmployees>
      <div class="no-data">No employees found for this 3 week range.</div>
    </ng-template>
  }
</div>